import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { Menu, MenuItem, Typography } from '@mui/material';

import { Iconify } from 'src/components/iconify';

interface ActivityDatePreferenceActionsMenuProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  onEdit: () => void;
  onDelete: () => void;
}

export const ActivityDatePreferenceActionsMenu = memo(
  ({ anchorEl, open, onClose, onEdit, onDelete }: ActivityDatePreferenceActionsMenuProps) => {
    const { t } = useTranslation(['activities', 'common']);

    return (
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={onClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{
          paper: {
            sx: {
              minWidth: 160,
              borderRadius: 1,
              boxShadow: (theme) => theme.customShadows.dropdown,
            },
          },
        }}
      >
        <MenuItem
          onClick={() => {
            onEdit();
            onClose();
          }}
        >
          <Iconify icon="solar:pen-bold" sx={{ mr: 1 }} />
          <Typography fontSize={14}>{t('common:actions.edit')}</Typography>
        </MenuItem>
        <MenuItem
          onClick={() => {
            onDelete();
            onClose();
          }}
          sx={{ color: 'error.main' }}
        >
          <Iconify icon="solar:trash-bin-trash-bold" sx={{ mr: 1 }} />
          <Typography fontSize={14} color="error.main">
            {t('common:actions.delete')}
          </Typography>
        </MenuItem>
      </Menu>
    );
  }
);

ActivityDatePreferenceActionsMenu.displayName = 'ActivityDatePreferenceActionsMenu';
